export default __webpack_public_path__ + "static/media/Lira-Bara_ Uganda--08.030223.ed46fd5a.JPG";